import React from "react";
import { LaunchParamsContext } from "../launchParamsContext";
import { StartAppParams } from "../types";

const getStartAppParams = (startAppParam: string) => {
  let input = startAppParam.replace(/-/g, '+').replace(/_/g, '/');

  // Pad out with standard base64 required padding characters
  const pad = input.length % 4;
  if(pad) {
    if(pad === 1) {
      throw new Error('InvalidLengthError: Input base64url string is the wrong length to determine padding');
    }
    input += new Array(5-pad).join('=');
  }
  const decoded = new TextDecoder().decode(Uint8Array.from(atob(input), c => c.charCodeAt(0)));
  return JSON.parse(decoded) as StartAppParams;
}

export const useStartAppParams = (): StartAppParams | null => {
  const lp = React.useContext(LaunchParamsContext);

  const startAppParams = React.useMemo(() => {
    if (!lp?.tgWebAppStartParam) {
      return null;
    }
    return getStartAppParams(lp.tgWebAppStartParam);
  }, [lp]);

  return startAppParams;
};
